module.exports = __webpack_public_path__ + "static/media/invite-coworker-icon.efeb0aa9.svg";